import React from 'react';

const RecruitNav = () => {
  return (
    <div className="local_nav">
      <ul>
        <li><a href="https://www.mandarake.co.jp/recruit/index.html">採用<br className="sponly" />情報</a></li>
        <li><a href="https://www.mandarake.co.jp/recruit/staff.html">入社後<br className="sponly" />紹介</a></li>
        <li><a href="https://www.mandarake.co.jp/recruit/shinsotsu.html">新卒者<br className="sponly" />採用</a></li>
        <li><a href="https://www.mandarake.co.jp/recruit/mid">通常<br className="sponly" />採用</a></li>
        <li><a href="https://www.mandarake.co.jp/recruit/obo.html">応募<br className="sponly" />方法</a></li>
        <li><a href="https://www.mandarake.co.jp/recruit/benefit.html">福利<br className="sponly" />厚生</a></li>
        <li><a href="https://www.mandarake.co.jp/recruit/club.html">部活動</a></li>
      </ul>
    </div>
  );
};

export default RecruitNav;